import { render, staticRenderFns } from "./AddMechanizationsModal.vue?vue&type=template&id=12dc1a9f&scoped=true"
import script from "./AddMechanizationsModal.vue?vue&type=script&lang=js"
export * from "./AddMechanizationsModal.vue?vue&type=script&lang=js"
import style0 from "./AddMechanizationsModal.vue?vue&type=style&index=0&id=12dc1a9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc1a9f",
  null
  
)

export default component.exports